import LoadingButton from 'components/Common/LoadingButton';
import { axiosbaseurl } from 'configure';
import { validateContact } from 'helpers/common_helper';
import { setUpdatedData } from 'helpers/data_setters';
import React, { useEffect, useState } from 'react'
import { Modal, ModalBody } from "reactstrap"

const AddSingleItem = ({ show, setShow, settable_data, itemName, setItemName,
    heading, api_name, fieldName, isBudgetMaster = false, budgetAmt, isWorkTypeMaster = false, correspondenceType }) => {

    // Individual states for each field
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    // reset states
    useEffect(() => {
        if (!show) {
            setItemName("")
            setError("")
            if (isWorkTypeMaster) correspondenceType.setValue("")
        }
    }, [show])

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            if (itemName) {
                setLoading(true)
                const response = await axiosbaseurl.post(`/${api_name}`,
                    {
                        [fieldName]: itemName,
                        ...(isBudgetMaster ? { value: budgetAmt.value } : {}),
                        ...(isWorkTypeMaster ? { correspondenceType: correspondenceType.value } : {})
                    });
                setShow(false)
                settable_data(prev => setUpdatedData(prev, { ...response.data.data }, "add"))
                setItemName("")

                if (isBudgetMaster) { 
                    budgetAmt.setValue('')
                }

            }
        } catch (error) {
            setError(error.response.data.message)
            console.log(error)
        } finally {
            setLoading(false)
        }
    }


    return (
        <Modal size="md" isOpen={show} toggle={() => {
            setShow(!show)
            setError("")
        }} centered={true}>
            <div className="modal-content">
                <ModalBody className="px-3 ">
                    <div className='d-flex justify-content-between pb-2 border-bottom'>
                        <h5 className='text-capitalize'>Add {heading}</h5>
                        <button type="button" className="btn-close " onClick={() => setShow(!show)}></button>
                    </div>

                    <div>
                        {
                            error && <div className="alert alert-danger">{error}</div>
                        }
                    </div>

                    <form onSubmit={handleSubmit} className='mt-4'>
                        <div className="mb-3">
                            <label className='text-capitalize'>{heading} Name <span className='text-danger'>*</span></label>
                            <input
                                type="text"
                                placeholder={`Enter ${heading} `}
                                value={itemName}
                                onChange={(e) => setItemName(e.target.value)}
                                className="form-control input-field"
                                required
                            />
                        </div>

                        {
                            isBudgetMaster ?
                                <div className="mb-3">
                                    <label className='text-capitalize'>Cost Per Hour (£) <span className='text-danger'>*</span></label>
                                    <input
                                        type="text"
                                        placeholder={`Enter Cost`}
                                        value={budgetAmt.value}
                                        onChange={(e) => budgetAmt.setValue(e.target.value)}
                                        onKeyDown={validateContact}
                                        className="form-control input-field"
                                        required
                                    />
                                </div>
                                : null
                        }

                        {
                            isWorkTypeMaster ?
                                <div className="mb-3">
                                    <label className='text-capitalize'>Correspondence Type <span className='text-danger'>*</span></label>
                                    <select
                                        value={correspondenceType.value}
                                        onChange={(e) => correspondenceType.setValue(e.target.value)}
                                        className="form-select input-field"
                                        required
                                    >
                                        <option value="">Select Correspondence Type</option>
                                        <option value="Internal Correspondence">Internal Correspondence</option>
                                        <option value="External Correspondence">External Correspondence</option>
                                        <option value="N/A">N/A</option>
                                    </select>
                                </div>
                                : null
                        }

                        <div className='text-center mt-4'>
                            <LoadingButton loading={loading} />
                        </div>

                    </form>

                </ModalBody>
            </div>
        </Modal>
    )
}

export default AddSingleItem